module.exports = __webpack_public_path__ + "img/layout3.e8261bd0.png";